import React from 'react';
import cn from 'classnames';

import { formatUsersList } from 'client/utils/filter-users-list';

import { selectShouldInitPubnub } from 'client/redux/ui/selectors';
import { selectActiveSpeakers } from 'client/redux/pubnub/selectors';
import { selectRoomDbData, selectRoomId } from 'client/redux/room/selectors';
import { selectUserRoomRole, selectUserUID } from 'client/redux/client/selectors';

import { useLiveStreamContext } from 'client/components/LiveStreamConnector/context';
import { ROOM_STATUS, USER_ROLES } from 'constants/index';
import { useAppSelector } from 'client/hooks';

import SpeakerIcon from './SpeakerIcon';
import RoomBottomContent from './RoomBottomContent';

import css from './RoomContent.module.scss';

const RoomContent: React.FC = () => {
  const roomData = useAppSelector(selectRoomDbData);
  const activeSpeakers = useAppSelector(selectActiveSpeakers);
  const roomId = useAppSelector(selectRoomId);
  const shouldInitPubnub = useAppSelector(selectShouldInitPubnub);
  const users = formatUsersList(roomData);
  const { state } = useLiveStreamContext();
  const userRole = useAppSelector((state) => selectUserRoomRole(state, roomId));
  const userId = useAppSelector(selectUserUID);
  const participantsIDs = state.participants.map((p) => p.identity);

  return (
    <div className={cn(css.container, !shouldInitPubnub && css.withoutFooter)}>
      <div className={css.roomInfo}>
        <div className={css.title}>
          <span>{roomData?.title}</span>
        </div>
        <div className={css.subtitle}>
          <span>{roomData?.description}</span>
        </div>
        <div className={css.speakersI}>
          <div className={css.speakers}>
            {users.map((speaker) => {
              return (
                <SpeakerIcon
                  roomId={roomData?._id || ''}
                  userData={speaker}
                  // we need to show online indication for speakers and host)
                  isLoggedIn={
                    (participantsIDs.includes(speaker.uid ?? '') && userRole !== USER_ROLES.LISTENER) ||
                    speaker.uid === userId
                  }
                  key={speaker._id}
                  isSpeaking={
                    roomData?.status === ROOM_STATUS.ACTIVE &&
                    activeSpeakers.includes((speaker.uid as string) || speaker._id || '')
                  }
                />
              );
            })}
          </div>
        </div>
      </div>
      <RoomBottomContent />
    </div>
  );
};

export default React.memo(RoomContent);
